export { AlignmentTypes, StyleTypes } from '../text-block/types.js';

var MediaTypes;
(function (MediaTypes) {
    MediaTypes["IMAGE"] = "image";
    MediaTypes["VIDEO"] = "video";
    MediaTypes["NONE"] = "none";
})(MediaTypes || (MediaTypes = {}));
var MediaAlignmentTypes;
(function (MediaAlignmentTypes) {
    MediaAlignmentTypes["LEFT"] = "left";
    MediaAlignmentTypes["RIGHT"] = "right";
    MediaAlignmentTypes["TOP"] = "top";
})(MediaAlignmentTypes || (MediaAlignmentTypes = {}));
var TextAlignmentTypes;
(function (TextAlignmentTypes) {
    TextAlignmentTypes["LEFT"] = "left";
    TextAlignmentTypes["CENTER"] = "center";
    TextAlignmentTypes["TOP"] = "top";
})(TextAlignmentTypes || (TextAlignmentTypes = {}));
var TitleAlignmentTypes;
(function (TitleAlignmentTypes) {
    TitleAlignmentTypes["LEFT"] = "left";
    TitleAlignmentTypes["CENTER"] = "center";
})(TitleAlignmentTypes || (TitleAlignmentTypes = {}));
var VideoTypes;
(function (VideoTypes) {
    VideoTypes["YOUTUBE"] = "YouTube";
    VideoTypes["VIMEO"] = "Vimeo";
    VideoTypes["LOCAL"] = "Local";
})(VideoTypes || (VideoTypes = {}));

export { MediaAlignmentTypes, MediaTypes, TextAlignmentTypes, TitleAlignmentTypes, VideoTypes };
